import moment from 'moment'
import { type Dispatch, type SetStateAction } from 'react'

import { type IFeedbackMode, type IFeedbackDto } from '@/app/types/doctorsType'
import { Button, Datepicker, CustomField, TextArea, Modal } from '@/shared'

import style from './PublishFeedback.module.scss'
import { useFields } from './useFields'

interface IProps {
    onAddFeedback: (dto: Omit<IFeedbackDto, 'doctorId'>, onSuccess: () => void) => void
    show: boolean
    onClose: () => void
    isFetchingFeedbacks: boolean
    setMode: Dispatch<SetStateAction<IFeedbackMode[]>>
}

export const PublishFeedback = (props: IProps) => {
    const { onAddFeedback, show, onClose, isFetchingFeedbacks, setMode } = props

    const {
        fio,
        onChangeFio,
        onTouchFio,
        onZeroFio,
        date,
        onChangeDate,
        onZeroDate,
        content,
        onChangeContent,
        onTouchContent,
        onZeroContent,
        isValidFields
    } = useFields()

    const onHandlePublish = () => {
        const onSuccess = () => {
            onZeroFio()
            onZeroDate()
            onZeroContent()
            onClose()
            setMode([
                { title: 'Опубликованные', isPublished: true, isChecked: false },
                { title: 'Неопубликованные', isPublished: false, isChecked: true }
            ])
        }
        onAddFeedback(
            {
                author: fio.value,
                content: content.value,
                createdAt: moment(date.value).format('YYYY-MM-DDTHH:mm:ss[Z]')
            },
            onSuccess
        ) // e.format('YYYY-MM-DDTHH:mm:ss[Z]'
    }

    const onCloseModal = () => {
        onZeroFio()
        onZeroDate()
        onZeroContent()
        onClose()
    }

    return (
        <Modal show={show} onClose={onCloseModal}>
            <div className={style.container}>
                <div className={style.userFields}>
                    <CustomField
                        value={fio.value}
                        placeholder={fio.placeholder}
                        name={fio.name}
                        onChange={onChangeFio}
                        onFocus={onTouchFio}
                        onZeroText={onZeroFio}
                    />
                    <Datepicker value={date.value} onChange={onChangeDate} />
                </div>
                <div className={style.content}>
                    <TextArea
                        value={content.value}
                        onChange={onChangeContent}
                        placeholder={content.placeholder}
                        onTouch={onTouchContent}
                        scrollHeight={60}
                    />
                </div>
                <div className={style.action}>
                    <Button onClick={onHandlePublish} disabled={isValidFields || isFetchingFeedbacks}>
                        Опубликовать
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
